// import { CONSTANTS, RountingPath } from "./constants.model";

export class WatchColumn {
    columnName: string;
    width: number;
    isHidden: boolean;
}

export class WatchStock {
    Symbol: string;
    Product: string;
    Exch: string;
    Board: string;
}

export class OrderEntry {
    priceType: string;
    timeinforce: string;
    isqtyallowed: boolean;
    defaultqty: number;
    orderpreview: boolean;
}

export class MarketWatchPreferenceInfo {
    marketWatchPreferenceInfo: {}
}

export class IndexList {
    items: {}
}

export class UserPreference {

    userName: string;
    themeName: string;
    language: string;

    userPreference: any = {
        DefaultList: [],
        preferredList: [],
        orderentry: {},
        indexinfo: [],
        landingPage: ''  // RountingPath.TABS_HOME,//"/tabs/home"
    };

    /**
     * @deprecated This should not be used in mobile
     */
    marketMatrixDepthDetails: string = null;
    // /**
    //  * @deprecated This should not be used in mobile
    //  */
    tickerSpeed: string = null;
    // /**
    //  * @deprecated This should not be used in mobile
    //  */
    selectedStock: any = null;
    /**
     * @deprecated This should not be used in mobile
     */
    // selectedStock: {"stock":"MYPORTFOLIO","filter":[]}
    marketWatchColumn: null;
    // marketWatchColumn: { mobilePreference: boolean, colInfo: WatchColumn[], sortInfo: { sortType: string, sortReverse: boolean } };
}

export interface IFilterData {
    symbol: string,
    sortingFiled: string,
    sortReverse: boolean,
    status: string,
    [key: string]: any;
}
